import React from "react";
import '../src/Components/Style.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Services from "./Components/Services";
import Blog from "./Pages/Blog";
import Contact from "./Pages/Contact";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import ScrollToTop from "./Components/ScrollToTop";
import Thankyou from "./Pages/Thankyou";
import NewsThankyou from "./Pages/NewsThankyou";
import Login from "./Pages/Login";
import AddBlog from "./Pages/AddBlog";
import AllBlog from "./Pages/AllBlog";
import EditBlog from "./Pages/EditBlog";
import BlogDetail from "./Pages/BlogDetail";
import Newsletter from "./Pages/Newsletter";
import Google from "./Pages/Google";
import ChangePassword from "./Pages/ChangePassword";
import WhatsappChange from "./Pages/WhatsappChange";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';

function AppContent() {
  const location = useLocation();
  const hideNavbarRoutes = ["/add-blog", "/all-blog", "/login", "/newsletter", "/google", "/change-password", "/whatsapp"];
  const hideNavbar =
    hideNavbarRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/edit-blog");

  return (
    <>
      {!hideNavbar && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/thankyou-newsletter" element={<NewsThankyou />} />
        <Route path="/login" element={<Login />} />
        <Route path="/add-blog" element={<AddBlog />} />
        <Route path="/all-blog" element={<AllBlog />} />
        <Route path="/edit-blog/:slug" element={<EditBlog />} />
        <Route path="/blog-detail/:slug" element={<BlogDetail />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/google" element={<Google />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/whatsapp" element={<WhatsappChange />} />
        

      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
